import { LanguageType } from "@/custom-types";
import { OrderDirectionOption } from "@/graphql/generated";

export const orderDirectionMapper = (direction: OrderDirectionOption, language: LanguageType) => {
  const texts = {
    en: {
      ASC: 'Ascending',
      DESC: 'Descending',
    },
    es: {
      ASC: 'Ascendente',
      DESC: 'Descendente',
    }
  }

  return texts[language][direction]
}

